import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconCorporateLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.566 20.577a1.2 1.2 0 0 1-1.2-1.2v-15.1a1.2 1.2 0 0 1 1.2-1.2h7.1a1.2 1.2 0 0 1 1.2 1.2v2.8h8.569a1.2 1.2 0 0 1 1.2 1.2v11.1a1.2 1.2 0 0 1-1.2 1.2H3.564Zm.3-1.5h6.5v-2.5h-6.5v2.5Zm0-4h6.5v-2.5h-6.5v2.5Zm0-4h6.5v-2.5h-6.5v2.5Zm0-4h6.5v-2.5h-6.5v2.5Zm8 12h8.269v-10.5h-8.27v10.5Zm2.942-6.5a.75.75 0 1 1 0-1.5H17a.75.75 0 0 1 0 1.5h-2.192Zm0 4a.75.75 0 1 1 0-1.5H17a.75.75 0 0 1 0 1.5h-2.192Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconCorporateLine;
